import {BaseDtoModel} from '../../Services/Models/base-model.service';
import {endOfMonth, format, startOfMonth} from 'date-fns';

export class WidgetFilters extends BaseDtoModel {
  fecha_inicio!: string;
  fecha_fin!: string;
  local!: { id: number, nombre: string };

  constructor(dataJson?: any) {
    super(dataJson);

    this.init({
      fecha_inicio: format(startOfMonth(new Date()), 'yyyy-MM-dd'),
      fecha_fin: format(endOfMonth(new Date()), 'yyyy-MM-dd'),
      local: {
        id: 0,
        nombre: '',
      },
    });
  }
}
